import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageWK4 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "2026 WK League Full Fixtures",
            author: "footballgirl",
           date: "March, 2026",
            image: "images/wk/4a.jpg",
           content: `<h3>Korea Women's Football Federation Announces 2026 WK League Schedule</h3>
<p>The <strong>Korea Women's Football Federation (KWFF)</strong> has officially released the regular season schedule for the <strong>2026 WK League</strong>, South Korea’s top-tier women’s football competition.</p>

<h3>Participating Teams and Season Format</h3>
<p>A total of eight teams will compete in the 2026 WK League:</p>
<ul>
  <li>Hwacheon KSPO Women's Football Team</li>
  <li>Seoul City Hall</li>
  <li>Incheon Hyundai Steel</li>
  <li>Gyeongju Hanwha WFC</li>
  <li>Sejong Sportstoto Women's Football Team</li>
  <li>Sangmu Women's Football Team</li>
  <li>Suwon FC Women</li>
  <li>Jeonnamgangjin SWANSWFC</li>
</ul>
<p>Each team will play <strong>28 matches</strong>, bringing the total number of matches in the league to <strong>112</strong>.</p>

<h3>Season Kickoff</h3>
<p>The opening matches of the 2026 WK League will take place at <strong>2 p.m. on Saturday, April 4</strong>, at each team’s respective home stadium. The season will feature the reigning champion, <strong>Hwacheon KSPO</strong>, and <strong>Jeonnamgangjin SWANSWFC</strong>, which recently relocated from Changnyeong, Gyeongnam, to Gangjin, Jeollanam. The regular season will continue until <strong>October 31</strong>, followed by playoffs and the championship finals.</p>

<h3>Increased Weekend and Holiday Matches</h3>
<p>For the 2026 season, the KWFF has significantly increased the proportion of matches scheduled on weekends and public holidays. Out of the 112 total matches, <strong>53 matches</strong> are slated for Saturdays, Sundays, or holidays, representing nearly half of the league’s fixtures. This is the highest percentage of weekend matches in the WK League’s history.</p>

<h3>Goals Behind the Weekend Scheduling</h3>
<p>The federation explained that this adjustment is intended to make it easier for fans to attend games in person. By boosting accessibility and encouraging stadium visits, the KWFF aims to foster a stronger spectator culture and increase the league’s overall popularity.</p>

<h3>Potential Schedule Adjustments</h3>
<p>While the 2026 WK League schedule has been 
released, minor changes may occur depending on 
each team’s stadium availability and other 
competition commitments.</p> <h3>대한축구협회, 2026 WK리그 정규시즌 일정 발표</h3>
<p><strong>대한축구협회 여자축구위원회(KWFF)</strong>가 대한민국 최고 수준의 여자축구 리그인 <strong>2026 WK리그</strong> 정규시즌 일정을 공식 발표했다.</p>

<h3>참가 팀 및 시즌 형식</h3>
<p>2026 WK리그에는 총 8개 팀이 참가한다:</p>
<ul>
  <li>화천 KSPO 여자축구단</li>
  <li>서울시청 여자축구단</li>
  <li>인천 현대제철 여자축구단</li>
  <li>경주 한화 WFC</li>
  <li>세종 스포츠토토 여자축구단</li>
  <li>상무 여자축구단</li>
  <li>수원 FC 여자축구단</li>
  <li>전남강진 SWANS WFC</li>
</ul>
<p>각 팀은 <strong>28경기</strong>를 치르며, 리그 전체 경기 수는 <strong>112경기</strong>에 달한다.</p>

<h3>시즌 개막</h3>
<p>2026 WK리그 개막 경기는 <strong>4월 4일 토요일 오후 2시</strong> 각 팀의 홈 경기장에서 동시에 열린다. 이번 시즌에는 지난 시즌 챔피언인 <strong>화천 KSPO</strong>와 창녕, 경남에서 전남 강진으로 연고지를 이전한 <strong>전남강진 SWANS WFC</strong>가 포함된다. 정규시즌은 <strong>10월 31일</strong>까지 진행되며, 이후 플레이오프와 챔피언 결정전이 이어진다.</p>

<h3>주말·공휴일 경기 확대</h3>
<p>2026 시즌부터 KWFF는 주말과 공휴일 경기 비율을 대폭 늘렸다. 전체 112경기 중 <strong>53경기</strong>가 토요일, 일요일 또는 공휴일에 예정되어 있어 리그 전체 경기의 거의 절반을 차지한다. 이는 WK리그 역사상 가장 높은 주말 경기 비율이다.</p>

<h3>주말 경기 확대의 목표</h3>
<p>협회는 이번 일정 조정이 팬들의 경기 관람 접근성을 높이기 위한 것이라고 설명했다. 관중의 경기장 방문을 활성화하고 팬 문화 정착을 촉진하여 리그의 인기를 높이는 것이 이번 전략의 핵심 목표다.</p>

<h3>일정 변경 가능성</h3>
<p>2026 WK리그 일정은 이미 발표되었지만, 각 팀의 경기장 사용 여부와 다른 대회 일정에 따라 소폭 조정될 가능성이 있다.</p>`,
             tags: ["WK League 2026", 
                "Korea Women’s Football",
                "WK League Schedule", 
                "2026 WK리그", 
                "Women’s Football Korea",
                "KWFF Fixtures",
                "한국 여자축구",
                "WK리그 일정",
                "여자축구 한국",
                 "KWFF 경기 일정"],
           navIndices: { prev: 'wk-3', next: 'wk-5' }
        });
    }

    init() {
        console.log('ArticlePageWK4 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to WK League
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'wk' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_wk.png';
            leagueLogo.alt = 'WK League';
        }
    }
}